import React from "react"
import Button from '@mui/material/Button'
import BotaoVoltar from "./common/botaoVoltar";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import { URL_API } from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';

class ConsultarEnvios extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			listaEnvios: [],
			afs: [],
			srfs: [],
			prefeituras: [],
			afMarcados: [],
			srfMarcados: [],
			prefeituraMarcados: [],
			tipoDestino: "",
			tipoConteudo: "",
			dataInicial: "",
			dataFinal: "",
			tudoAf: [],
			tudoSrf: [],
			tudoPrefeitura: [],
			mostraAf:  "none",
			mostraSrf:  "none",
			mostraPrefeitura:  "none",
			lista: [],
			dados: [],
			loader: false
		}
	}

	componentDidMount() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}
		
		fetchWithToken(`${URL_API}/api/v1/af/obterAf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados da AF"
				}
				else {
					this.setState({ afs: res });
					let itens = [];
					res.map((item) => (
						itens[item.codigo] = false
					))
					this.afMarcados= itens;
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados da SRF"
				}
				else {
					this.setState({ srfs: res });
					let itens = [];
					res.map((item) => (
						itens[item.codigo] = false
					))
					this.setState({ srfMarcados: itens });
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
		fetchWithToken(`${URL_API}/api/v1/prefeitura/obterPrefeitura`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados da Prefeitura"
				}
				else {
					this.setState({ prefeituras: res });
					let itens = [];
					res.map((item) => (
						itens[item.codigo] = false
					))
					this.setState({ prefeituraMarcados: itens });
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
		const hoje = new Date();
		const data = hoje.getFullYear() + "-" + ('0' + (hoje.getMonth() + 1)).slice(-2) + "-" + ('0' + hoje.getDate()).slice(-2)
		this.setState({ dataInicial: data})
		this.setState({ dataFinal: data})
	}

	buscar() {
		this.setState({ loader: true })
		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded',"Authorization": `Bearer ${token_keycloack}` },
			body: "tipoConteudo=" + this.state.tipoConteudo +
				"&tipoDestino=" + this.state.tipoDestino +
				"&dataInicial=" + this.state.dataInicial +
				"&dataFinal=" + this.state.dataFinal +
				"&lista=" + this.state.lista
		};
		fetchWithToken(`${URL_API}/api/v1/envio/consulta`, requestOptions)
			.then(res => res.json())
			.then(res => {
				this.setState({ loader: false })
				this.setState({ dados: res})
				this.setState({ listaEnvios: res})
				$(document).ready(function () {
					setTimeout(function () {
						$('#tblResultados1').DataTable({
							columnDefs: [
								{ orderable: false, targets: 0 }
							],
							lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
							pageLength: 30,
							emptyTable: "Pesquisa sem resultados!",
							infoEmpty: "Pesquisa sem resultados!",
							language: {
								url: '/pt-BR.json'
							}
						});
					}, 100);
				});	
				if(res && res.length === 0){
					alert("Pesquisa sem resultados!");
				}
			})
			.catch(_err => {
				alert("Ocorreu um erro!")
				console.error("Ocorreu um erro - " + _err)
			});
		return false
	}

	controlarTipoDestino(e) {
		
		this.setState({ tipoDestino: e.target.value})
		if (e.target.value === "P") {

			this.setState({ mostraAf: "none"})
			this.setState({ mostraSrf: "none"})
			this.setState({ mostraPrefeitura: "block"})
			$(document).ready(function () {
				setTimeout(function () {
					$('#tblPrefeitura').DataTable({
						columnDefs: [
							{ orderable: false, targets: 0 }
						],
						lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
							pageLength: 5,
						language: {
							url: '/pt-BR.json'
						}
					});
				}, 100);
			});
		}
		else if (e.target.value === "A") {
			this.setState({ mostraAf: "block"})
			this.setState({ mostraSrf: "none"})
			this.setState({ mostraPrefeitura: "none"})
			$(document).ready(function () {
				setTimeout(function () {
					$('#tblAf').DataTable({
						columnDefs: [
							{ orderable: false, targets: 0 }
						],
						lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
							pageLength: 5,
						language: {
							url: '/pt-BR.json'
						}
					});
				}, 100);
			});
		}
		else if (e.target.value === "S") {
			this.setState({ mostraAf: "none"})
			this.setState({ mostraSrf: "block"})
			this.setState({ mostraPrefeitura: "none"})
		}
		this.setState({ tudoPrefeitura: false})
		this.setState({ tudoAf: false})
		this.setState({ tudoSrf: false})
		let itens = [];
		this.state.afs.map((item) => (
			itens[item.idAr] = false
		))
	}

	controlarTipoConteudo(e) {
		this.setState({ tipoConteudo: e.target.value})
		return null
	}

	controlarDataInicial(e) {
		this.setState({ dataInicial: e.target.value})
		return null
	}

	controlarDataFinal(e) {
		this.setState({ dataFinal: e.target.value})
		return null
	}

	controlarTudoAf(e) {
		this.setState({ tudoAf: e.target.checked})
		const itens = [];
		const tmp = [];
		this.state.afs.map((item) => {
			itens[item.codigo] = e.target.checked
			tmp.push(item.email)
			return null
		})
		this.setState({ lista: tmp})
		this.setState({ afMarcados: itens})
		return null
	}

	controlarTudoSrf(e) {
		this.setState({ tudoSrf: e.target.checked})
		const itens = [];
		const tmp = [];
		this.state.srfs.map((item) => {
			itens[item.codigo] = e.target.checked
			tmp.push(item.email)
			return null
		})
		this.setState({ lista: tmp})
		this.setState({ srfMarcados: itens})
		return null
	}

	controlarTudoPrefeitura(e) {
		this.setState({ tudoPrefeitura: e.target.checked})
		const itens = [];
		const tmp = [];
		this.state.prefeituras.map((item) => {
			itens[item.codigo] = e.target.checked
			tmp.push(item.email)
			return null
		})
		this.setState({ lista: tmp})
		this.setState({ prefeituraMarcados: itens})
		return null
	}

	controlarItem(e) {
		if (e.target.type === "checkbox") {
			let id = e.target.id.substring(1,4)
			if (e.target.id.substring(0, 1) === "a") {
				let item = this.state.afMarcados[id];
				this.state.afMarcados[id] = !item;
				this.setState({ afMarcados: this.state.afMarcados });
				let tmp = this.state.lista
				tmp.push(e.target.value)
				this.setState({ lista: tmp})
			}
			else if (e.target.id.substring(0, 1) === "p") {
				let item = this.state.prefeituraMarcados[id];
				this.state.prefeituraMarcados[id] = !item;
				this.setState({ prefeituraMarcados: this.state.prefeituraMarcados });
				let tmp = this.state.lista
				tmp.push(e.target.value)
				this.setState({ lista: tmp})
			}
			else if (e.target.id.substring(0, 1) === "s") {
				let item = this.state.srfMarcados[id];
				this.state.srfMarcados[id] = !item;
				this.setState({ srfMarcados: this.state.srfMarcados });
				let tmp = this.state.lista
				tmp.push(e.target.value)
				this.setState({ lista: tmp})
			}
		}
		return null
	}

	render() 
	{
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<header className="main">
							<h2>DISTVAF - Consultar Envios</h2>
						</header>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<BotaoVoltar />
					</div>
				</div>
				{(this.state.loader && <DistVafCircularProgress />)}
				<form>
					<div className="row">
					<div className="col-12">
						<Paper variant="outlined">
							<div className="cabecalho">
								Filtros
							</div>
							<div className="col-12 ">
								<FormGroup>
									<FormControl sx={{ m: 3 }}>
										<label id="lblTipoDestino" >Tipo do destino</label>
										<Select label="Tipo do Destino" name="tipoDestino" id="cmbTipoDestino" value={this.state.tipoDestino} labelId="lblTipoDestino" onChange={(e) => {this.controlarTipoDestino(e)}}>
											<MenuItem value={"P"}>Prefeitura</MenuItem>
											<MenuItem value={"A"}>AF</MenuItem>
											<MenuItem value={"S"}>SRF</MenuItem>
										</Select>
									</FormControl>
									<FormControl sx={{ m: 3 }}>
										<label id="lblTipoConteudo" >Tipo do conteúdo</label>
										<Select name="tipoConteudo" id="cmbTipoConteudo" value={this.state.tipoConteudo} labelId="lblTipoConteudo" onChange={(e) => {this.controlarTipoConteudo(e)}}>
											<MenuItem value={"AT"}>Contribuintes Ativos</MenuItem>
											<MenuItem value={"RT"}>Retorno</MenuItem>
										</Select>
									</FormControl>
									<FormControl sx={{ m: 3 }}>
										<label id="lblTipoConteudo">Data inicial</label>
										<input type="date" name="dataInicial" id="dataInicial" value={this.state.dataInicial} onChange={(e) => {this.controlarDataInicial(e)}} />
									</FormControl>
									<FormControl sx={{ m: 3 }}>
										<label id="lblTipoConteudo">Data final</label>
										<input type="date" name="dataFinal" id="dataFinal" value={this.state.dataFinal} onChange={(e) => {this.controlarDataFinal(e)}} />
									</FormControl>
								</FormGroup>
							</div>
							<div className="col-12" id="listaAr" style={{ display: this.state.mostraAf }} hi>
							<div className="cabecalho">Seleção de AF</div>
								<div className="table-wrapper">
									<table id="tblAf" className="table table-hover table-bordered">
										<thead>
											<tr>
												<th className='caixa'><input type="checkbox" id="chkTudoAf" checked={this.state.tudoAf} onChange={(e) => {this.controlarTudoAf(e)}} /><label htmlFor="chkTudoAf"> </label></th>
												<th>AF</th>
											</tr>
										</thead>
										<tbody>
											{this.state.afs.map( (reg) => {
												return (
													<tr key={"a" + reg.codigo}>
														<td className='caixa'><input type="checkbox" id={"a" + reg.codigo} value={reg.email} checked={this.state.afMarcados[reg.codigo] || false} onChange={(e) => {this.controlarItem(e)}} /><label htmlFor={"a" + reg.codigo}></label></td>
														<td>{reg.nome}</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
							</div>
						
							<div className="col-12" id="listaSrf" style={{ display: this.state.mostraSrf }}>
								<FormControl variant="standard" sx={{ m: 1, minWidth: "100%" }}>
								<div className="cabecalho">Seleção de SRF</div>
									<div className="table-wrapper">
										<table id="tblSrf" className="table table-hover table-bordered">
											<thead>
												<tr>
													<th className='caixa'><input type="checkbox" id="chkTudoSrf" checked={this.state.tudoSrf} onChange={(e) => {this.controlarTudoSrf(e)}} /><label htmlFor="chkTudoSrf"> </label></th>
													<th>SRF</th>
												</tr>
											</thead>
											<tbody>
												{this.state.srfs.map( (reg) => {
													return (
														<tr key={"s" + reg.codigo}>
															<td className='caixa'><input type="checkbox" id={"s" + reg.codigo} value={reg.email} checked={this.state.srfMarcados[reg.codigo] || false} onChange={(e) => {this.controlarItem(e)}} /><label htmlFor={"s" + reg.codigo}></label></td>
															<td>{reg.nome}</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</FormControl>
							</div>
							<div className="col-12" id="listaPrefeituras" style={{ display: this.state.mostraPrefeitura }}>
								<FormControl variant="standard" sx={{ m: 1, minWidth: "100%" }}>
									<div className="cabecalho">Seleção de Prefeituras</div>
									<div className="table-wrapper">
										<table id="tblPrefeitura" className="table table-hover table-bordered">
											<thead>
												<tr>
													<th className='caixa'><input type="checkbox" id="chkTudoPrefeitura" checked={this.state.tudoPrefeitura} onChange={(e) => {this.controlarTudoPrefeitura(e)}} /><label htmlFor="chkTudoPrefeitura"> </label></th>
													<th>Município</th>
												</tr>
											</thead>
											<tbody>
												{this.state.prefeituras.map( (reg) => {
													return (
														<tr key={"p" + reg.codigo}>
															<td className='caixa'><input type="checkbox" id={"p" + reg.codigo} value={reg.email} checked={this.state.prefeituraMarcados[reg.codigo] || false} onChange={(e) => {this.controlarItem(e)}} /><label htmlFor={"p" + reg.codigo}></label></td>
															<td>{reg.nome}</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</FormControl>
							</div>
							<div className="col-12">
								<FormControl variant="standard" sx={{ m: 1 }}>
									<Button variant="contained" color="primary" onClick={ () => this.buscar()}>Buscar</Button>
								</FormControl>
							</div>
						
					</Paper>
					</div>
					</div>
				</form>
				{ this.state.listaEnvios != null ? 
					<div className="row">
						<div className="col-12">
						<Paper variant="outlined">
							<div className="cabecalho">
								Resultado
							</div>
							<div className="table-wrapper">
								<table id="tblResultados" className="table table-hover table-bordered">
									<thead>
										<tr>
											<th className="align-center">Data do envio</th>
											<th className="align-center">Descrição</th>
											<th className="align-center">Email</th>
											<th className="align-center">Arquivo</th>
										</tr>
									</thead>
									<tbody>
										{Array.isArray(this.state.dados) && this.state.dados.map(result => {
											return (
												<tr className="center" key={result.idEnvio}>
													<td className="align-center">{result.dataHora.substring(8, 10) + "/" + result.dataHora.substring(5, 7) + "/" + result.dataHora.substring(0, 4) + " - " + result.dataHora.substring(11, 13) + ":" + result.dataHora.substring(14, 16) + ":" + result.dataHora.substring(17, 19)}</td>
													<td className="align-center">{result.descricao}</td>
													<td className="align-center">{result.emailDestino}</td>
													<td className="align-center">{result.arquivoEnviado}</td>
												</tr>
											);
										})
										}
									</tbody>
								</table>
							</div>
							</Paper>
						</div>	
					</div>
			: "" }
				
			</div>
		)
	}
}
export default ConsultarEnvios